import { motion } from "framer-motion";
import { MANIFESTO } from "../../lib/constants";

export function Manifesto() {
  return (
    <section className="py-24 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-testid="manifesto-section">
      <span className="text-xs font-mono uppercase tracking-[0.25em] text-amber-light">The Orion Standard</span>
      <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl uppercase text-white mt-2 mb-14">Built On Uncompromising Duty</h2>

      <div className="space-y-14">
        {MANIFESTO.map((chapter, i) => (
          <motion.div
            key={chapter.number}
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.6, delay: i * 0.05 }}
            className="grid grid-cols-1 md:grid-cols-12 gap-6 border-t border-amber-500/15 pt-8"
            data-testid={`manifesto-chapter-${chapter.number}`}
          >
            <div className="md:col-span-2">
              <span className="font-display text-5xl md:text-6xl text-amber-500/25">{chapter.number}</span>
            </div>
            <div className="md:col-span-4">
              <h3 className="text-xl sm:text-2xl font-bold tracking-tight text-amber-100">{chapter.title}</h3>
              <p className="text-sm text-amber-light/70 mt-1">{chapter.subtitle}</p>
            </div>
            <div className="md:col-span-6">
              <p className="text-sm sm:text-base text-zinc-400 leading-relaxed">{chapter.description}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
